// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2395f298","867":"997e1549"}[chunkId] + ".chunk.js";
};